import { API_ENDPOINTS } from '../config/api';

const handleResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.message || 'Erro na requisição');
  }
  return data.data || {};
};

const register = async ({ email, password, displayName, companyName, businessSegment }) => {
  const response = await fetch(API_ENDPOINTS.AUTH_REGISTER, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password, displayName, companyName, businessSegment }),
  });
  const data = await handleResponse(response);
  return data.user;
};

const login = async ({ email, password }) => {
  const response = await fetch(API_ENDPOINTS.AUTH_LOGIN, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password }),
  });
  const data = await handleResponse(response);
  return data.user;
};

const logout = async () => {
  await fetch(API_ENDPOINTS.AUTH_LOGOUT, { method: 'POST', credentials: 'include' });
};

const getSession = async () => {
  const response = await fetch(API_ENDPOINTS.AUTH_SESSION, { credentials: 'include' });
  const data = await handleResponse(response);
  return data;
};

export default {
  register,
  login,
  logout,
  getSession,
};
